import $ from 'jquery';

$(() => {
  'use strict';

  // display image from redactor field to modal #page-content-image
  let src = 'http://placehold.it/200x200';
  $('.page-content a.image-popup-container').on('click', function(){
    src = $(this).find('img').attr('src');
    $('#page-content-image .modal-content img').attr('src', src);
  })
});